// eslint-disable-next-line no-undef
export const BASE_BACKEND_URL = GLOBAL_CONFIG.REACT_APP_APIM_URL;
// eslint-disable-next-line no-undef
export const ENVIRONMENT = GLOBAL_CONFIG.REACT_APP_ENVIRONMENT;

//export const MONITORING_URL = `http://localhost:7071/api/monitoring`;

export const MONITORING_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-monitoring/monitoring`;

export const SIGNALR_NEGOTIATE_URL = MONITORING_URL;

export const SIGNALR_NEGOTIATE_USER_URL = MONITORING_URL + "/user";
